import { IFormViewForm } from 'components/FormView';

export const LocalShipmentLeftPanelFrom: IFormViewForm = {
  id: 'LocalShipmentLeftPanelFrom',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 1,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Description',
            name: 'Description',
            placeholder: '',
            size: 'large',
            disabled: false,
            required: false,
          }
        },
        {
          id: 2,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Contact',
            name: 'Contact',
            placeholder: '',
            size: 'large',
            disabled: false,
            required: false,
          }
        },
        {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Freight code',
            name: 'FreightCode',
            size: 'small',
            disabled: false,
            lookupName: 'FreightCode',
            required: false,
          }
        },
        {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Send via',
            name: 'FreightType',
            size: 'small',
            disabled: false,
            lookupName: 'FreightType',
            required: false,
          }
        },
        {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Carrier',
            name: 'Carrier',
            size: 'large',
            disabled: false,
            lookupName: 'CarrierCode',
            required: false,
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Freight account',
            name: 'FreightAccount',
            placeholder: '',
            size: 'medium',
            disabled: false,
            required: false,
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Consignment Note',
            name: 'ConsignmentNote',
            placeholder: '',
            size: 'large',
            disabled: false,
            required: false,
          }
        },
        {
          id: 5,
          type: 'TEXT_AREA',
          props: {
            label: 'Comment',
            name: 'Comment',
            size: 'large',
            disabled: false,
            style: {
              'height': '138px',
              '& .MuiFormLabel-root': {
                paddingTop: 0,
              }
            },
          }
        }
      ]
    },
  ]
};

export const LocalShipmentRightPanelFrom: IFormViewForm = {
  id: 'LocalShipmentRightPanelFrom',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 3,
          type: 'DATE_FIELD',
          visible: true,
          props: {
            label: 'ETA',
            name: 'EstimatedArrivalDate',
            nullable: 'true',
            size: 'small',
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
          }
        },
        {
          id: 3,
          type: 'DATE_FIELD',
          visible: true,
          props: {
            label: 'Dispatched',
            name: 'DespatchedDate',
            size: 'small',
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
          }
        },
        {
          id: 2,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Cartons',
            name: 'Cartons',
            placeholder: '',
            size: 'small',
          }
        },
        {
          id: 2,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Pallets',
            name: 'Pallets',
            placeholder: '',
            size: 'small',
            disabled: false,
            required: false,
          }
        },
        {
          id: 3,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Weight',
            name: 'Weight',
            placeholder: '',
            size: 'medium',
            disabled: false,
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 4
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Cubic',
            name: 'CubicSize',
            placeholder: '',
            size: 'medium',
            disabled: false,
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 4
          }
        },
      ]
    },
  ]
};
